// extracted by mini-css-extract-plugin
export default {"form":"ChangePassword_form__b+2gh","submitBtn":"ChangePassword_submitBtn__2tAGh","msgError":"ChangePassword_msgError__5bEgr","msgSuccess":"ChangePassword_msgSuccess__zKDyW"};